import { Box } from '@mui/material';
import CreateFab from '../components/CreateFab';
import EventsList from '../components/EventsList';
import DefaultLayout from '../layouts/DefaultLayout';
import GlobalHeader from '../components/GlobalHeader';

export default function EventsListScreen() {
    return (
        <DefaultLayout>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    width: '100%',
                    height: '100%',
                    boxSizing: 'border-box',
                    alignItems: 'center',
                }}
            >
                <GlobalHeader title="Events" />
                <EventsList />
                <CreateFab />
            </Box>
        </DefaultLayout>
    );
}
